import { SubmissionError } from 'redux-form';
import { getPotentialDestinations } from '../../containers/Dashboard/DashboardActions';

const valid = (data, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(getPotentialDestinations({
      terminalId: data.terminal.value,
      orgId: data.orgId,
      city: data.city,
      state: data.state,
      zip: data.zip
    }, (err, json) => {
      if (err) {
        return reject(err);
      }
      if(json.exact){
        return resolve(data);
      }
      if (json.match.length  > 0) {
        let items = [`Did you mean?`];
        json.match.forEach(m  => {
          items.push(`${m.destination},  ${m.state} ${m.zip}`);
        });
        return reject({
          _error: items
        });
      } else {
        let err = ["There are no matching destinations for this terminal", "Please try a different, Terminal, City, State or ZIP Code."];
        return reject({
          _error: err
        });
      }
    }));
  });
};

const submitValidate = (data, dispatch, props) => {
  let {orgId, onSubmit} = props;
  data.orgId = orgId;
  return valid(data, dispatch)
    .then(value => onSubmit(value))
    .catch(err => { throw new SubmissionError(err);});
};

export default submitValidate;



// WEBPACK FOOTER //
// ./src/components/FacilityToDestinationForm/SubmitValidate.js